const API_URL = process.env.REACT_APP_BACKEND_URL;

const SESSION_KEY = "shopthing_session_id";

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

// Fire-and-forget POST
function send(eventType, payload) {
  const body = {
    eventType,
    sessionId: getSessionId(),
    timestamp: new Date().toISOString(),
    payload,
  };
  fetch(`${API_URL}/api/analytics/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).catch(() => {});
}

// Dedup sets (reset on page load, which is fine)
const viewedProducts = new Set();
const appOpenedThisSession = sessionStorage.getItem("analytics_app_opened");

export function trackAppOpen() {
  if (appOpenedThisSession) return;
  sessionStorage.setItem("analytics_app_opened", "1");
  send("app_open", {});
}

export function trackEventClick(eventId, eventTitle) {
  send("event_click", { eventId, eventTitle });
}

export function trackProductView(productId, eventId, productIndex) {
  const key = `${eventId}:${productId}`;
  if (viewedProducts.has(key)) return;
  viewedProducts.add(key);
  send("product_view", { productId, eventId, productIndex });
}

// Debounced swipe depth — avoids rapid-fire POSTs during fast swiping
let swipeDepthTimer = null;
let pendingSwipeDepth = null;

export function trackSwipeDepth(eventId, maxProductIndex) {
  pendingSwipeDepth = { eventId, maxProductIndex };
  if (swipeDepthTimer) clearTimeout(swipeDepthTimer);
  swipeDepthTimer = setTimeout(() => {
    if (pendingSwipeDepth) {
      send("swipe_depth", pendingSwipeDepth);
      pendingSwipeDepth = null;
    }
    swipeDepthTimer = null;
  }, 300);
}

export function trackBuyClick(productId, eventId, productName, price) {
  send("buy_click", { productId, eventId, productName, price });
}
